import { render, staticRenderFns } from "./ToDoTasksTable.vue?vue&type=template&id=3fc24b7b&scoped=true&lang=pug"
import script from "./ToDoTasksTable.vue?vue&type=script&lang=ts"
export * from "./ToDoTasksTable.vue?vue&type=script&lang=ts"
import style0 from "./ToDoTasksTable.vue?vue&type=style&index=0&id=3fc24b7b&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc24b7b",
  null
  
)

export default component.exports